import React, { useEffect } from 'react';
import { useInView } from '../hooks/useInView';
import { teamMembers } from '../data/teamMembers';
import AvatarPlaceholder from '../components/ui/AvatarPlaceholder';

const TeamPage: React.FC = () => {
  useEffect(() => {
    document.title = 'Our Team | Janssen Law Professional Corporation';
  }, []);

  const featuredSection = useInView();
  const gridSection = useInView();

  const featured = teamMembers.find((m) => m.featured);
  const others = teamMembers.filter((m) => !m.featured);

  return (
    <div className="team-page">
      <section className="team-hero">
        <h1>Our Team</h1>
        <p>Experienced professionals dedicated to providing exceptional legal counsel.</p>
      </section>

      <div className="team-content">
        {/* Featured Member - Charlotte */}
        {featured && (
          <div
            ref={featuredSection.ref}
            className={`featured-member ${featuredSection.isVisible ? 'visible' : ''}`}
          >
            <div className="member-photo">
              <AvatarPlaceholder initials={featured.initials} size={240} />
            </div>
            <div className="member-info">
              <h2>{featured.name}</h2>
              <div className="member-title">{featured.title}</div>
              <p className="member-bio">{featured.bio}</p>

              <div className="member-details">
                <div>
                  <h3>Education</h3>
                  <ul>
                    {featured.education?.map((edu) => (
                      <li key={edu}>{edu}</li>
                    ))}
                  </ul>
                </div>
                <div>
                  <h3>Bar Admission</h3>
                  <p>{featured.barAdmission}</p>

                  <h3 style={{ marginTop: '1.5rem' }}>Professional Memberships</h3>
                  <p>
                    Member of the Law Society of Upper Canada, Canadian Bar Association,
                    Ontario Bar Association. Canadian Representative to The Hague
                    Conference on International Law (2012).
                  </p>
                </div>
              </div>

              <div className="member-practice-areas">
                <h3>Areas of Practice</h3>
                <div className="practice-tags">
                  {featured.practiceAreas.map((area) => (
                    <span key={area}>{area}</span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Team Grid */}
        <div className="team-grid-header">
          <h2>Our Lawyers & Staff</h2>
          <p>Meet the professionals who support your legal matters every day.</p>
        </div>

        <div
          ref={gridSection.ref}
          className={`team-grid ${gridSection.isVisible ? 'visible' : ''}`}
        >
          {others.map((member) => (
            <div key={member.name} className="team-card">
              <div className="member-photo">
                <AvatarPlaceholder initials={member.initials} size={140} />
              </div>
              <h3>{member.name}</h3>
              <div className="card-title">{member.title}</div>
              <p className="card-bio">{member.bio}</p>
              {member.practiceAreas.length > 0 && (
                <div className="card-practice-areas">
                  {member.practiceAreas.map((area) => (
                    <span key={area}>{area}</span>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TeamPage;
